<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip, attrs }">
      <v-btn
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...tooltip, ...$listeners }"
        :icon="!hasSlotDefault()"
        :outlined="hasSlotDefault()"
        @click="goToLastDashboard"
      >
        <v-icon :left="hasSlotDefault()">mdi-view-dashboard</v-icon>
        <slot v-if="hasSlotDefault()" name="default"></slot>
      </v-btn>
    </template>
    <span>Workspace dashboard</span>
  </v-tooltip>
</template>

<script>
import { mapMutations } from 'vuex'

import Session from '@/models/Session'

export default {
  props: {},

  data: () => ({
    //
  }),

  computed: {},

  methods: {
    hasSlotDefault() {
      return !!this.$slots['default'] || !!this.$scopedSlots['default']
    },
    goToLastDashboard() {
      if (this.$route.name !== 'Dashboard') {
        if (Session.getWorkspaceId())
          this.$router.push({
            name: 'Dashboard',
            params: { workspaceId: Session.getWorkspaceId() },
          })
        else {
          this.toastSet({
            message: 'No default workspace: please choose a workspace',
            color: 'warning',
          })
          if (this.$route.name !== 'Settings') this.$router.push({ name: 'Settings' })
        }
      }
    },
    ...mapMutations(['toastSet']),
  },
}
</script>
